import type { RefObject, Dispatch, SetStateAction } from 'react';
import { Stack } from '@etg/wings';
import { useHeightContext, useProperty } from '@eti/providers';
import StickySidebar from '../../../../../widgets/sidebar/components/StickySidebar';
import FloatingSaveTripButton from '../../v3/FloatingSaveTripButton';
import type { Filters } from './MobileFilters';
import DesktopSidebarFilters from './DesktopSidebarFilters';
import DesktopDrawerFilters from './DesktopDrawerFilters';

interface DesktopFiltersProps {
  onClear: () => void;
  onFilter: (filter: any) => void;
  selectedFilters?: Filters;
  sidebarRef: RefObject<HTMLElement>;
  setIsItineraryDrawerSelfTransferModalOpen: Dispatch<SetStateAction<boolean>>;
}

const DesktopFilters = ({
  onClear,
  onFilter,
  selectedFilters,
  setIsItineraryDrawerSelfTransferModalOpen,
  sidebarRef,
}: DesktopFiltersProps) => {
  const { p } = useProperty();
  const isDrawerEnabled = p('Result.Page.V3.DesktopDrawerSearchResultFilters.Enabled');
  const { headerHeightContext } = useHeightContext();

  return isDrawerEnabled ? (
    <DesktopDrawerFilters onClear={onClear} onFilter={onFilter} selectedFilters={selectedFilters} />
  ) : (
    <StickySidebar containerRef={sidebarRef} topSpacing={headerHeightContext}>
      <Stack spacing={16}>
        <FloatingSaveTripButton
          setIsItineraryDrawerSelfTransferModalOpen={setIsItineraryDrawerSelfTransferModalOpen}
        />
        <DesktopSidebarFilters
          onClear={onClear}
          onFilter={onFilter}
          selectedFilters={selectedFilters}
        />
      </Stack>
    </StickySidebar>
  );
};

export default DesktopFilters;
